import { TYPE_REQUIRED, TYPE_UNMATCHED_ACCOUNT } from 'constants/errors'
import { accountNumberSchema, alphaNumericStringSchema, bankAccountTypeSchema, fullNameSchema, routingNumberSchema } from 'helpers/schemaHelpers'
import { schemaNumber, schemaString } from 'schemas/baseSchema'
import * as yup from 'yup'

export const createCardPaymentSchema = yup.object({
  payment_method: schemaString,
  payment_amount_type: schemaString,
  // amount: schemaString,
  payment_date: schemaString,
})


export const createCardAutoPaymentSchema = yup.object({
  payment_method: schemaString,
  payment_amount_type: schemaString,
  // amount: schemaString,
  days_before_due_date: schemaNumber,
})


export const createCardPaymentMethodSchema = yup.object({
  account_type: bankAccountTypeSchema,
  cardholder_name: fullNameSchema,
  routing_number: routingNumberSchema,
  account_number: accountNumberSchema,
  confirm_account_number: yup.string().test('passwords-match', TYPE_UNMATCHED_ACCOUNT, function () {
    return this.parent.account_number === this.parent.confirm_account_number
  }).required(TYPE_REQUIRED),
  bank_name: alphaNumericStringSchema,
})
